(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woolique-about-brand"]) return;
  try {
    
(() => {
  const instanceKey = '__wooliqueStoryArtMotionV1';
  if (window[instanceKey]) {
    window[instanceKey].refresh(document);
    return;
  }

  const roots = new Map();
  const motionQuery = typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;
  let removalObserver = null;

  const disconnectWhenSettled = (state) => {
    if (state.observer && [...state.items.values()].every((item) => item.status === 'settled')) {
      state.observer.disconnect();
      state.observer = null;
    }
  };

  const settleItem = (state, art, item) => {
    if (item.status === 'settled') return;
    item.status = 'settled';
    item.animations.forEach((animation) => animation.cancel());
    item.animations.clear();
    if (state.observer) state.observer.unobserve(art);
    disconnectWhenSettled(state);
  };

  const disposeRoot = (root, state) => {
    state.disposed = true;
    state.items.forEach((item, art) => settleItem(state, art, item));
    if (state.observer) state.observer.disconnect();
    state.observer = null;
    state.items.clear();
    roots.delete(root);
  };

  const prune = () => {
    roots.forEach((state, root) => {
      if (!root.isConnected) {
        disposeRoot(root, state);
        return;
      }
      state.items.forEach((item, art) => {
        if (!root.contains(art)) {
          settleItem(state, art, item);
          state.items.delete(art);
        }
      });
      disconnectWhenSettled(state);
    });
    if (!roots.size && removalObserver) {
      removalObserver.disconnect();
      removalObserver = null;
    }
  };

  const canAnimate = () => !document.hidden
    && !(motionQuery && motionQuery.matches)
    && typeof window.IntersectionObserver === 'function';

  const targetsFor = (art) => {
    if (art.dataset.storyArt !== 'fan') {
      const image = art.querySelector('img');
      return image ? [image] : [];
    }
    const pieces = [...art.querySelectorAll('[data-art-piece]')];
    const images = pieces.length
      ? pieces.map((piece) => piece.matches('img') ? piece : piece.querySelector('img'))
      : [...art.querySelectorAll('img')];
    return [...new Set(images.filter(Boolean))].slice(0, 3);
  };

  const animateItem = (state, art, item) => {
    if (state.disposed || !canAnimate()) {
      settleItem(state, art, item);
      return;
    }
    const kind = art.dataset.storyArt;
    const images = targetsFor(art).filter((image) => image.isConnected && typeof image.animate === 'function');
    if (!images.length) {
      settleItem(state, art, item);
      return;
    }
    item.status = 'running';
    try {
      images.forEach((image, index) => {
        const restingStyle = window.getComputedStyle(image);
        const restingTransform = restingStyle.transform === 'none' ? '' : restingStyle.transform;
        const restingOpacity = restingStyle.opacity || (kind === 'wash' ? '0.14' : '1');
        let entrance = 'scale(0.97)';
        let duration = 850;
        let delay = 0;

        if (kind === 'wash') {
          entrance = 'translate3d(12px, 0, 0)';
          duration = 1100;
        } else if (kind === 'wrap') {
          entrance = 'translate3d(-20px, 0, 0) rotate(-7deg)';
          duration = 900;
        } else if (kind === 'fan') {
          entrance = `translate3d(0, 20px, 0) rotate(${[-5, 3, 5][index]}deg)`;
          duration = 850;
          delay = index * 100;
        }

        const animation = image.animate([
          { opacity: '0', transform: `${entrance} ${restingTransform}`.trim() },
          { opacity: restingOpacity, transform: restingTransform || 'none' }
        ], {
          duration,
          delay,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          iterations: 1,
          fill: 'backwards'
        });
        item.animations.add(animation);
      });
      Promise.allSettled([...item.animations].map((animation) => animation.finished))
        .then(() => settleItem(state, art, item));
    } catch (error) {
      settleItem(state, art, item);
    }
  };

  const initializeRoot = (root) => {
    if (roots.has(root) || !root.isConnected) return;
    const arts = [...root.querySelectorAll('[data-story-art]')]
      .filter((art) => ['wash', 'wrap', 'fan', 'note'].includes(art.dataset.storyArt));
    if (!arts.length) return;
    const state = { items: new Map(), observer: null, disposed: false };
    arts.forEach((art) => state.items.set(art, { status: 'pending', animations: new Set() }));
    roots.set(root, state);

    if (!canAnimate()) {
      state.items.forEach((item, art) => settleItem(state, art, item));
      return;
    }

    state.observer = new window.IntersectionObserver((entries) => {
      if (!root.isConnected || state.disposed) {
        prune();
        return;
      }
      entries.forEach((entry) => {
        const item = state.items.get(entry.target);
        if (!item || item.status === 'settled') return;
        if (entry.isIntersecting && item.status === 'pending') {
          animateItem(state, entry.target, item);
        } else if (!entry.isIntersecting && item.status === 'running') {
          settleItem(state, entry.target, item);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -24px 0px' });
    arts.forEach((art) => state.observer.observe(art));
  };

  const refresh = (scope) => {
    prune();
    if (scope.matches && scope.matches('.wq-story-depth')) initializeRoot(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('.wq-story-depth').forEach(initializeRoot);
    if (roots.size && !removalObserver && typeof window.MutationObserver === 'function') {
      removalObserver = new window.MutationObserver(prune);
      removalObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
  };

  const settleAll = () => {
    roots.forEach((state) => state.items.forEach((item, art) => settleItem(state, art, item)));
  };
  const onVisibilityChange = () => {
    if (document.hidden) settleAll();
  };
  const onSectionLoad = (event) => refresh(event.target);
  const onSectionUnload = (event) => {
    roots.forEach((state, root) => {
      if (event.target === root || (event.target.contains && event.target.contains(root))) {
        disposeRoot(root, state);
      }
    });
    prune();
  };
  const onReady = () => refresh(document);
  const destroy = () => {
    roots.forEach((state, root) => disposeRoot(root, state));
    if (removalObserver) removalObserver.disconnect();
    removalObserver = null;
    document.removeEventListener('DOMContentLoaded', onReady);
    document.removeEventListener('visibilitychange', onVisibilityChange);
    document.removeEventListener('shopify:section:load', onSectionLoad);
    document.removeEventListener('shopify:section:unload', onSectionUnload);
    if (motionQuery) {
      if (motionQuery.removeEventListener) motionQuery.removeEventListener('change', settleAll);
      else if (motionQuery.removeListener) motionQuery.removeListener(settleAll);
    }
    delete window[instanceKey];
  };

  window[instanceKey] = { refresh, destroy };
  document.addEventListener('visibilitychange', onVisibilityChange);
  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
  if (motionQuery) {
    if (motionQuery.addEventListener) motionQuery.addEventListener('change', settleAll);
    else if (motionQuery.addListener) motionQuery.addListener(settleAll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady, { once: true });
  else onReady();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woolique-editorial-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', event => {
    if (!event.target.matches('.wq-catalogue [data-wcg-sort]')) return;
    const url = new URL(window.location.href);
    if (event.target.value) url.searchParams.set('sort_by', event.target.value);
    else url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woolique-editorial-page"]) return;
  try {
    
  function enhanceWooliqueAnswers(scope) {
    scope.querySelectorAll('[data-wq-page="faq"] .wl-faq-answers').forEach((answers) => {
      if (answers.dataset.wqEnhanced) return;
      const questions = [...answers.querySelectorAll(':scope > h3')];
      questions.forEach((heading, index) => {
        const nodes = [];
        let sibling = heading.nextElementSibling;
        while (sibling && !['H2', 'H3'].includes(sibling.tagName) && !sibling.classList.contains('wl-faq-more')) {
          nodes.push(sibling);
          sibling = sibling.nextElementSibling;
        }
        if (!nodes.length) return;
        const details = document.createElement('details');
        details.className = 'wq-page__answer';
        details.open = index === 0;
        const summary = document.createElement('summary');
        summary.append(...heading.childNodes);
        const icon = answers.closest('[data-wq-page]').querySelector('[data-wq-disclosure-icon]');
        if (icon) summary.append(icon.content.cloneNode(true));
        const content = document.createElement('div');
        content.className = 'wq-page__answer-content';
        nodes.forEach((node) => content.append(node, document.createTextNode('\n')));
        details.append(summary, document.createTextNode('\n'), content);
        heading.replaceWith(details);
      });
      answers.dataset.wqEnhanced = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhanceWooliqueAnswers(document));
  else enhanceWooliqueAnswers(document);
  document.addEventListener('shopify:section:load', (event) => enhanceWooliqueAnswers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woolique-gallery-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const namespace = 'WooliqueGalleryHome';
  const selector = '[data-wq-gallery-home]';
  if (window[namespace]) {
    window[namespace].mount(document);
    return;
  }
  const instances = new Map();
  const rootsWithin = (scope) => {
    const roots = Array.from(scope.querySelectorAll ? scope.querySelectorAll(selector) : []);
    if (scope.matches && scope.matches(selector)) roots.unshift(scope);
    return roots;
  };
  const create = (root) => {
    const removers = [];
    const observers = [];
    const gallery = root.querySelector('.gallery');
    const track = root.querySelector('.gallery-track');
    const slides = track ? Array.from(track.querySelectorAll('.gallery-slide')) : [];
    const dots = Array.from(root.querySelectorAll('[data-gallery-index]'));
    const status = root.querySelector('[data-gallery-status]');
    const media = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    const filters = Array.from(root.querySelectorAll('[data-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-category]'));
    const filterStatus = root.querySelector('[data-filter-status]');
    const reveals = Array.from(root.querySelectorAll('[data-reveal]')).filter((element) => !element.closest('.hero-intro, .gallery'));
    let reduced = Boolean(media && media.matches);
    let index = 0;
    let hovering = false;
    let focused = Boolean(gallery && gallery.contains(document.activeElement));
    let inView = !('IntersectionObserver' in window);
    let dragging = false;
    let touching = false;
    let drag = null;
    let blockedClick = false;
    let disposed = false;
    let autoTimer = 0;
    let scrollTimer = 0;
    let releaseTimer = 0;
    let resizeFrame = 0;
    let scrolling = false;
    let revealObserver = null;
    const on = (element, name, handler, options) => {
      if (!element) return;
      element.addEventListener(name, handler, options);
      removers.push(() => element.removeEventListener(name, handler, options));
    };
    const galleryArtMedia = window.matchMedia('(min-width:750px)');
    const galleryArt = Array.from(root.querySelectorAll('[data-gallery-art]'));
    const loadGalleryArt = (element) => {
      if (!galleryArtMedia.matches || element.dataset.galleryArtLoaded) return;
      element.style.backgroundImage = 'url(' + JSON.stringify(element.dataset.galleryArt) + ')';
      element.dataset.galleryArtLoaded = 'true';
    };
    const galleryArtObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && galleryArtMedia.matches) {
          loadGalleryArt(entry.target);
          galleryArtObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' }) : null;
    if (galleryArtObserver) observers.push(galleryArtObserver);
    const observeGalleryArt = () => {
      if (!galleryArtMedia.matches) return;
      galleryArt.filter((element) => !element.dataset.galleryArtLoaded).forEach((element) => {
        if (galleryArtObserver) galleryArtObserver.observe(element);
        else loadGalleryArt(element);
      });
    };
    on(galleryArtMedia, 'change', observeGalleryArt);
    observeGalleryArt();
    const clearAuto = () => {
      window.clearTimeout(autoTimer);
      autoTimer = 0;
    };
    const positions = () => {
      if (!track || !slides.length) return [];
      const start = slides[0].offsetLeft;
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      return slides.map((slide) => Math.max(0, Math.min(slide.offsetLeft - start, maximum)));
    };
    const nearest = () => {
      const values = positions();
      return values.reduce((best, value, current) => Math.abs(value - track.scrollLeft) < Math.abs(values[best] - track.scrollLeft) ? current : best, 0);
    };
    const render = () => {
      dots.forEach((dot) => {
        const active = Number(dot.dataset.galleryIndex) === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      slides.forEach((slide, number) => slide.classList.toggle('is-current', number === index));
      if (status && slides.length) {
        status.setAttribute('aria-live', reduced || focused ? 'polite' : 'off');
        status.textContent = `${index + 1} / ${slides.length} — ${slides[index].dataset.label || ''}`;
      }
    };
    const schedule = () => {
      clearAuto();
      if (disposed || !track || reduced || hovering || focused || !inView || document.hidden || dragging || touching || scrolling || slides.length < 2) return;
      autoTimer = window.setTimeout(() => goTo(index + 1), 4000);
    };
    const moveTrack = (left, animated) => {
      if (!track) return;
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left, behavior: animated && !reduced ? 'smooth' : 'instant' });
      } else {
        track.scrollLeft = left;
      }
    };
    const goTo = (next) => {
      if (!track || !slides.length || disposed) return;
      index = ((next % slides.length) + slides.length) % slides.length;
      moveTrack(positions()[index] || 0, true);
      render();
      schedule();
    };
    const sync = () => {
      scrolling = true;
      clearAuto();
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        scrolling = false;
        if (disposed || dragging) return;
        index = nearest();
        render();
        schedule();
      }, 150);
    };
    const finishDrag = () => {
      if (!drag || !track) return;
      const previousDrag = drag;
      const wasDrag = dragging;
      drag = null;
      dragging = false;
      if (typeof track.hasPointerCapture === 'function' && track.hasPointerCapture(previousDrag.pointerId)) {
        track.releasePointerCapture(previousDrag.pointerId);
      }
      track.classList.remove('is-dragging');
      track.style.scrollSnapType = previousDrag.snap;
      track.style.scrollBehavior = previousDrag.behavior;
      if (wasDrag) {
        goTo(nearest());
        window.clearTimeout(releaseTimer);
        releaseTimer = window.setTimeout(() => { blockedClick = false; }, 500);
      } else {
        schedule();
      }
    };
    const resize = () => {
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(() => {
        resizeFrame = 0;
        if (!disposed && track && !dragging) moveTrack(positions()[index] || 0, false);
      });
    };
    const show = (element) => {
      if (reduced || !revealObserver) element.classList.remove('reveal-ready');
      element.classList.add('is-visible');
      if (revealObserver) revealObserver.unobserve(element);
    };
    const refreshReveals = () => {
      reveals.forEach((element) => {
        if (element.hidden) {
          if (revealObserver) revealObserver.unobserve(element);
          return;
        }
        if (reduced || !revealObserver) {
          show(element);
        } else if (!element.classList.contains('is-visible')) {
          element.classList.add('reveal-ready');
          revealObserver.observe(element);
        }
      });
    };
    const filter = (button, announce = true) => {
      const category = button.dataset.filter;
      let count = 0;
      filters.forEach((item) => {
        const active = item === button;
        item.classList.toggle('selected', active);
        item.setAttribute('aria-pressed', String(active));
      });
      cards.forEach((card) => {
        const visible = category === 'all' || card.dataset.category === category;
        card.hidden = !visible;
        if (visible) {
          card.style.setProperty('--reveal-delay', `${count * 65}ms`);
          count += 1;
        }
      });
      if (filterStatus && announce) filterStatus.textContent = `${button.textContent.trim()} — ${count}`;
      refreshReveals();
    };
    if ('IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !entry.target.hidden) show(entry.target);
        });
      }, { threshold: 0.1 });
      observers.push(revealObserver);
      if (track) {
        const galleryObserver = new IntersectionObserver(([entry]) => {
          inView = entry.isIntersecting && entry.intersectionRatio >= 0.15;
          schedule();
        }, { threshold: [0, 0.15] });
        galleryObserver.observe(track);
        observers.push(galleryObserver);
      }
    } else if (track) {
      const checkView = () => {
        const rect = track.getBoundingClientRect();
        inView = rect.bottom > 0 && rect.top < window.innerHeight;
        schedule();
      };
      on(window, 'scroll', checkView, { passive: true });
      checkView();
    }
    if (track && slides.length) {
      index = nearest();
      on(track, 'scroll', sync, { passive: true });
      on(track, 'touchstart', () => { touching = true; clearAuto(); }, { passive: true });
      const finishTouch = (event) => {
        touching = event.touches.length > 0;
        schedule();
      };
      on(window, 'touchend', finishTouch, { passive: true });
      on(window, 'touchcancel', finishTouch, { passive: true });
      on(track, 'wheel', schedule, { passive: true });
      on(track, 'dragstart', (event) => event.preventDefault());
      on(track, 'pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        window.clearTimeout(releaseTimer);
        blockedClick = false;
        drag = { x: event.clientX, left: track.scrollLeft, pointerId: event.pointerId, snap: track.style.scrollSnapType, behavior: track.style.scrollBehavior };
      });
      on(track, 'pointermove', (event) => {
        if (!drag || event.pointerId !== drag.pointerId) return;
        const distance = event.clientX - drag.x;
        if (Math.abs(distance) <= 6 && !dragging) return;
        if (!dragging) {
          dragging = true;
          blockedClick = true;
          clearAuto();
          track.classList.add('is-dragging');
          track.style.scrollSnapType = 'none';
          track.style.scrollBehavior = 'auto';
          if (typeof track.setPointerCapture === 'function') track.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        track.scrollLeft = drag.left - distance;
      });
      on(track, 'pointerup', finishDrag);
      on(track, 'pointercancel', finishDrag);
      on(track, 'lostpointercapture', finishDrag);
      on(window, 'pointerup', finishDrag);
      on(window, 'blur', () => { touching = false; finishDrag(); schedule(); });
      on(track, 'click', (event) => {
        if (!blockedClick) return;
        event.preventDefault();
        event.stopPropagation();
        blockedClick = false;
      }, true);
      on(track, 'keydown', (event) => {
        if (!['ArrowRight', 'ArrowLeft'].includes(event.key) || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
        event.preventDefault();
        goTo(index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(resize);
        resizeObserver.observe(track);
        slides.forEach((slide) => resizeObserver.observe(slide));
        observers.push(resizeObserver);
      } else {
        on(window, 'resize', resize, { passive: true });
      }
    }
    on(gallery, 'mouseenter', () => { hovering = true; schedule(); });
    on(gallery, 'mouseleave', () => {
      hovering = false;
      if (drag && !dragging) drag = null;
      schedule();
    });
    on(gallery, 'focusin', () => { focused = true; schedule(); });
    on(gallery, 'focusout', (event) => {
      focused = Boolean(event.relatedTarget && gallery.contains(event.relatedTarget));
      schedule();
    });
    on(document, 'visibilitychange', () => {
      if (document.hidden) touching = false;
      schedule();
    });
    root.querySelectorAll('[data-gallery-prev]').forEach((button) => {
      button.disabled = slides.length < 2;
      on(button, 'click', () => goTo(index - 1));
    });
    root.querySelectorAll('[data-gallery-next]').forEach((button) => {
      button.disabled = slides.length < 2;
      on(button, 'click', () => goTo(index + 1));
    });
    dots.forEach((button) => on(button, 'click', () => {
      const next = Number(button.dataset.galleryIndex);
      if (Number.isInteger(next) && next >= 0 && next < slides.length) goTo(next);
    }));
    const updateMotion = () => {
      reduced = Boolean(media && media.matches);
      render();
      schedule();
      refreshReveals();
    };
    if (media) {
      if (typeof media.addEventListener === 'function') on(media, 'change', updateMotion);
      else if (typeof media.addListener === 'function') {
        media.addListener(updateMotion);
        removers.push(() => media.removeListener(updateMotion));
      }
    }
    filters.forEach((button) => on(button, 'click', () => filter(button)));
    if (filters.length) filter(filters.find((button) => button.getAttribute('aria-pressed') === 'true') || filters[0], false);
    else refreshReveals();
    render();
    schedule();
    root.dataset.wqGalleryReady = 'true';
    return () => {
      disposed = true;
      finishDrag();
      clearAuto();
      window.clearTimeout(scrollTimer);
      window.clearTimeout(releaseTimer);
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      observers.forEach((observer) => observer.disconnect());
      removers.forEach((remove) => remove());
      reveals.forEach((element) => element.classList.remove('reveal-ready'));
      cards.forEach((card) => { card.hidden = false; });
      delete root.dataset.wqGalleryReady;
    };
  };
  const mount = (scope) => {
    rootsWithin(scope).forEach((root) => {
      if (!instances.has(root)) instances.set(root, create(root));
    });
  };
  const unmount = (scope) => {
    rootsWithin(scope).forEach((root) => {
      const dispose = instances.get(root);
      if (dispose) dispose();
      instances.delete(root);
    });
  };
  window[namespace] = { mount, unmount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => unmount(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woolique-product-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.wlpInit === 'true') return;
      const configNode = root.querySelector('[data-wlp-product-json]');
      if (!configNode) return;
      let config;
      try { config = JSON.parse(configNode.textContent); } catch { return; }
      const variants = config.variants || [];
      const form = root.querySelector('.wlp-product__form');
      const variantInput = root.querySelector('[data-wlp-variant-id]');
      if (!form || !variantInput || !variants.length) return;
      const groups = Array.from(root.querySelectorAll('[data-option-index]'));
      const price = root.querySelector('[data-wlp-price]');
      const compare = root.querySelector('[data-wlp-compare]');
      const badge = root.querySelector('[data-wlp-sale-badge]');
      const addButton = root.querySelector('[data-wlp-add]');
      const addText = root.querySelector('[data-wlp-add-text]');
      const message = root.querySelector('[data-wlp-message]');
      const dynamic = root.querySelector('[data-wlp-dynamic]');
      const quantity = root.querySelector('[data-wlp-qty]');
      const cards = Array.from(root.querySelectorAll('[data-media-id]'));
      const thumbnails = Array.from(root.querySelectorAll('[data-wlp-thumbnail]'));
      const thumbnailRail = root.querySelector('.wlp-product__thumbnails');
      const labels = config.labels;
      const addLabel = addButton?.dataset.addLabel || '';
      let activeVariant = variants.find((variant) => String(variant.id) === String(config.initialVariantId)) || variants[0];

      const showMedia = (id) => {
        const target = cards.find((card) => card.dataset.mediaId === String(id));
        if (!target) return;
        cards.forEach((card) => {
          const hidden = card !== target;
          if (hidden && !card.hidden) {
            card.querySelectorAll('video').forEach((video) => video.pause());
            card.querySelectorAll('iframe').forEach((frame) => {
              if (frame.src.includes('youtube.com')) frame.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', 'https://www.youtube.com');
              if (frame.src.includes('player.vimeo.com')) frame.contentWindow?.postMessage('{"method":"pause"}', 'https://player.vimeo.com');
            });
          }
          card.hidden = hidden;
        });
        const image = target.querySelector('img');
        if (image) image.loading = 'eager';
        thumbnails.forEach((thumbnail) => thumbnail.setAttribute('aria-pressed', String(thumbnail.dataset.wlpThumbnail === String(id))));
        const selectedThumbnail = thumbnails.find((thumbnail) => thumbnail.dataset.wlpThumbnail === String(id));
        if (selectedThumbnail && thumbnailRail) {
          const railBounds = thumbnailRail.getBoundingClientRect();
          const thumbnailBounds = selectedThumbnail.getBoundingClientRect();
          const offset = thumbnailBounds.left < railBounds.left + 3
            ? thumbnailBounds.left - railBounds.left - 3
            : Math.max(0, thumbnailBounds.right - railBounds.right + 3);
          if (offset) thumbnailRail.scrollBy({ left: offset, behavior: 'instant' });
        }
      };

      const selectOptions = (variant) => {
        groups.forEach((group, index) => group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === variant.options[index];
        }));
      };

      const selectedOptions = () => groups.map((group) => group.querySelector('input:checked')?.value);

      const findVariant = () => {
        if (!groups.length) return activeVariant;
        const options = selectedOptions();
        return variants.find((variant) => options.every((value, index) => variant.options[index] === value));
      };

      const updateOptions = () => {
        const selected = selectedOptions();
        groups.forEach((group, index) => {
          const label = group.querySelector('[data-selected-label]');
          if (label) label.textContent = selected[index] || '';
          group.querySelectorAll('input[type="radio"]').forEach((input) => {
            const available = variants.some((variant) => variant.available && variant.options[index] === input.value && selected.every((value, position) => position === index || variant.options[position] === value));
            const optionLabel = input.nextElementSibling;
            optionLabel?.classList.toggle('is-unavailable', !available);
            if (optionLabel) optionLabel.title = available ? '' : labels.soldOutOption;
          });
        });
      };

      const updateVariant = (variant, updateUrl = true) => {
        activeVariant = variant || null;
        variantInput.value = variant ? String(variant.id) : '';
        variantInput.disabled = !variant;
        if (price) price.textContent = variant ? config.prices[variant.id].price : labels.unavailable;
        const onSale = Boolean(variant && variant.compare_at_price > variant.price);
        if (compare) {
          compare.hidden = !onSale;
          compare.textContent = onSale ? config.prices[variant.id].compare : '';
        }
        if (badge) {
          badge.hidden = !onSale;
          badge.textContent = onSale ? labels.sale.replace('__PERCENT__', String(Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price))) : '';
        }
        if (addButton) addButton.disabled = !variant?.available;
        if (addText) addText.textContent = variant ? (variant.available ? addLabel : labels.soldOut) : labels.unavailable;
        if (dynamic) dynamic.hidden = !variant?.available;
        if (message) message.textContent = variant ? (variant.available ? '' : labels.soldOutOption) : labels.unavailableCombination;
        updateOptions();
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (variant) url.searchParams.set('variant', String(variant.id));
          else url.searchParams.delete('variant');
          window.history.replaceState(window.history.state, '', url);
        }
        const mediaId = (variant && config.prices[variant.id]?.mediaId) || variant?.featured_media?.id || config.defaultMediaId;
        if (mediaId) showMedia(mediaId);
      };

      const selectMedia = (mediaId) => {
        const matchingVariants = variants.filter((variant) => {
          const variantMediaId = config.prices[variant.id]?.mediaId || variant.featured_media?.id;
          return variantMediaId != null && String(variantMediaId) === String(mediaId);
        });
        if (matchingVariants.length === 1) {
          selectOptions(matchingVariants[0]);
          updateVariant(matchingVariants[0]);
        } else {
          showMedia(mediaId);
        }
      };

      const normaliseQuantity = () => {
        if (!quantity) return;
        const value = Number(quantity.value);
        quantity.value = String(Number.isFinite(value) ? Math.max(1, Math.floor(value)) : 1);
      };

      const stepMedia = (direction) => {
        if (cards.length < 2) return;
        const currentIndex = Math.max(0, cards.findIndex((card) => !card.hidden));
        const nextIndex = (currentIndex + direction + cards.length) % cards.length;
        selectMedia(cards[nextIndex].dataset.mediaId);
      };
      root.querySelector('[data-wlp-media-previous]')?.addEventListener('click', () => stepMedia(-1));
      root.querySelector('[data-wlp-media-next]')?.addEventListener('click', () => stepMedia(1));

      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => selectMedia(thumbnail.dataset.wlpThumbnail));
        thumbnail.addEventListener('keydown', (event) => {
          let nextIndex;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % thumbnails.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + thumbnails.length) % thumbnails.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = thumbnails.length - 1;
          if (nextIndex === undefined) return;
          event.preventDefault();
          thumbnails[nextIndex].focus({ preventScroll: true });
          selectMedia(thumbnails[nextIndex].dataset.wlpThumbnail);
        });
      });
      groups.forEach((group) => group.addEventListener('change', () => updateVariant(findVariant())));
      root.querySelector('[data-wlp-qty-minus]')?.addEventListener('click', () => {
        normaliseQuantity();
        if (quantity) quantity.value = String(Math.max(1, Number(quantity.value) - 1));
      });
      root.querySelector('[data-wlp-qty-plus]')?.addEventListener('click', () => {
        normaliseQuantity();
        if (quantity) quantity.value = String(Number(quantity.value) + 1);
      });
      quantity?.addEventListener('change', normaliseQuantity);
      form.addEventListener('submit', (event) => {
        const variant = findVariant();
        if (!variant?.available) {
          event.preventDefault();
          updateVariant(variant);
          return;
        }
        normaliseQuantity();
        variantInput.value = String(variant.id);
        variantInput.disabled = false;
        if (addText) addText.textContent = labels.adding;
      });
      const restoreFromUrl = () => {
        const variantId = new URL(window.location.href).searchParams.get('variant');
        const variant = variants.find((item) => String(item.id) === variantId) || variants.find((item) => String(item.id) === String(config.initialVariantId)) || variants[0];
        selectOptions(variant);
        updateVariant(variant, false);
      };
      window.addEventListener('popstate', restoreFromUrl);
      window.addEventListener('pageshow', restoreFromUrl);
      root.dataset.wlpInit = 'true';
      restoreFromUrl();
    };
    const initializeAll = (scope) => scope.querySelectorAll('[data-wlp-product]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
    else initializeAll(document);
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woolique-quiet-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  const activeDetail=event.target instanceof Element?event.target.closest('.wq-header details[open]'):null;
  document.querySelectorAll('.wq-header details[open]').forEach(detail=>{detail.open=false});
  if(activeDetail){event.preventDefault();activeDetail.querySelector(':scope > summary')?.focus()}
});
document.addEventListener('toggle',event=>{
  const detail=event.target;
  if(!(detail instanceof HTMLDetailsElement)||!detail.open)return;
  const header=detail.closest('.wq-header');
  if(!header)return;
  header.querySelectorAll('details[open]').forEach(other=>{if(other!==detail)other.open=false});
},true);
document.addEventListener('click',event=>{document.querySelectorAll('.wq-header details[open]').forEach(detail=>{if(!detail.contains(event.target))detail.open=false})});

  } catch(e) { console.error(e); }
})();
})();
